import { _$id, _addEventListener, } from '../util/dom';
import { _routeById, } from './route-registry';
import { _ldButtonId, } from './RouteLength';
import { _$ldForm, } from './route-length';
import { _addKeyHandlers, } from '../service/key-handlers';
const _selectedRoute = () => _selectedRouteCell, _routeIsSelected = (route) => (route === _selectedRouteCell), _selectRouteView = (route) => {
    if (_selectedRouteCell) {
        _deselectPanes(_selectedRouteCell);
    }
    _selectedRouteCell = route;
    const panes = route.p(), $markerPane = panes.mp(), $linePane = panes.lp();
    _selectPane($markerPane);
    _selectPane($linePane);
}, _selectRouteViewById = (routeId) => {
    const route = _routeById(routeId);
    if (!route) {
        return;
    }
    _selectRouteView(route);
}, _deselectRouteView = (route) => {
    if (route !== _selectedRouteCell) {
        return;
    }
    _deselectSelectedRouteView();
}, _deselectSelectedRouteView = () => {
    if (!_selectedRouteCell) {
        return;
    }
    _deselectPanes(_selectedRouteCell);
    _selectedRouteCell = null;
}, _selectPane = ($pane) => {
    $pane.classList.add(_selectedClass);
}, _deselectPanes = (route) => {
    const panes = route.p(), $markerPane = panes.mp(), $linePane = panes.lp();
    _deselectPane($markerPane);
    _deselectPane($linePane);
}, _deselectPane = ($pane) => {
    $pane.classList.remove(_selectedClass);
}, _selectRouteFromDdClick = (clickEvent) => {
    const $target = clickEvent.target;
    if (!($target instanceof HTMLInputElement)) {
        return;
    }
    const routeId = $target.value;
    if (routeId === undefined) {
        return;
    }
    if (routeId === _noSelectionValue) {
        _deselectSelectedRouteView();
    }
    else {
        _selectRouteViewById(routeId);
    }
}, _selectRoute = (route) => {
    const buttonId = _ldButtonId(route.p().id()), $ldButton = _$id(buttonId);
    _selectRouteView(route);
    $ldButton.checked = true;
}, _deselectRoute = (route) => {
    if (!route || !_routeIsSelected(route)) {
        return;
    }
    _deselectRouteView(route);
    _selectNoSelectionDisplay();
}, _deselectSelectedRoute = () => {
    _deselectRoute(_selectedRoute());
}, _selectNoSelectionDisplay = () => {
    _$ldButtonForNoSelection.checked = true;
}, _selectedClass = 'route-selected', _noSelectionValue = 'x', _ldButtonIdForNoSelection = _ldButtonId(_noSelectionValue), _$ldButtonForNoSelection = _$id(_ldButtonIdForNoSelection);
let _selectedRouteCell = null;
_addEventListener(_$ldForm, 'click', _selectRouteFromDdClick);
_addKeyHandlers('n', _deselectSelectedRoute);
_selectNoSelectionDisplay();
export { _selectRoute, _deselectRoute, _selectedRoute, _routeIsSelected, };
